/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Sales_ConsultantInputs */

const en_clients_field_sales_consultant = /** @type {(inputs: Clients_Field_Sales_ConsultantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales consultant`)
};

const pt_br2_clients_field_sales_consultant = /** @type {(inputs: Clients_Field_Sales_ConsultantInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consultor comercial`)
};

/**
* | output |
* | --- |
* | "Sales consultant" |
*
* @param {Clients_Field_Sales_ConsultantInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_sales_consultant = /** @type {((inputs?: Clients_Field_Sales_ConsultantInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Sales_ConsultantInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_sales_consultant(inputs)
	return pt_br2_clients_field_sales_consultant(inputs)
});